const actions = {
    GET_ACTIVE_CONSENTS: 'consentTypes/GET_ACTIVE_CONSENTS',
    SET_ACTIVE_CONSENTS: 'consentTypes/SET_ACTIVE_CONSENTS',

    GET_CONSENTS_STORY: 'consentTypes/GET_CONSENTS_STORY',
    SET_CONSENTS_STORY: 'consentTypes/SET_CONSENTS_STORY',

    SET_INITIAL_CONSENTS: "consents/SET_INITIAL_CONSENTS"

};

export default actions
